<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="view">
        <h2>
            <span v-b-tooltip.hover
                  :title="tooltipTitle">
                    Consulter vos demandes de dispenses
            </span>
        </h2>

        <div v-if="dispensesResult" class="mt-5">
            <div class="overflow-auto">
                <b-table striped hover
                         :no-local-sorting="true"
                         :items="dispensesTable" :fields="fields">
                    <template v-slot:cell(trimestres)="row">
                        <b-button size="sm" v-b-tooltip.hover :title="row.item.trimestres">
                            <Icon icon="info-circle" size="1x"></Icon>
                        </b-button>
                    </template>
                </b-table>
            </div>
        </div>
    </div>

</template>

<script>
  import ReportingStore from "../../stores/ReportingStore";
  import AlertStore from "../../stores/AlertStore";
  import {EventBus} from '@/event-bus'
  import ReportingSearchDto from "../../dtos/ReportingSearchDto";

  export default {
    components: {},
    props: ['onglet', 'marcheId'],
    data() {
      return {
        tooltipTitle: "Ces demandes sont générées lorsque vous cliquez sur le bouton \"Rien à déclarer\"",
        dispensesResult: null,
      }
    },
    computed: {
      fields() {
        return [
          {label: 'Trimestre de la dispense', key: 'trimestre', sortable: false},
          {label: 'Trimestre(s) concerné(s)', key: 'trimestres', sortable: false},
          {label: 'Date de demande de la dispense', key: 'createdDate', sortable: false},
        ];
      },
      dispensesTable: function () {
        return this.dispensesResult.map(dispense => {
          return {
            trimestre: dispense.trimestre.libelle,
            trimestres: dispense.trimestres.map(s => s.libelle).join(", "),
            createdDate: dispense.createdDate ? new Date(dispense.createdDate).toLocaleDateString() : null
          }
        });
      }
    },
    mounted() {
      EventBus.$on('NavBar-marcheChange', () => {
        this.search();
      });
      this.search();
    },
    methods: {
      search() {
        const search = new ReportingSearchDto();
        search.marcheId = this.marcheId;
        search.onglets = [this.onglet];
        ReportingStore.searchDispensesUtilisateur(search).then(
            result => {
              this.dispensesResult = result.data;
            },
            error => AlertStore.pushError(error.response.data.message)
        )
      }
    }
  }
</script>
